module.exports = __webpack_public_path__ + "img/9788992288149.ec3adc80.jpg";